<template>
	<div>
		<div class="warning">
			<el-alert v-if="maintenance" type="error" center closable @close="maintenance = false">
				{{ $t('maintenance') }}
			</el-alert>
		</div>
		<div id="app" :class="{ maintenance: maintenance }">
			<router-view></router-view>
			<div style="position: fixed; bottom: 2px; left: 2px; z-index: 999999; font-size: 9px; color: #ddd">version: {{
				releaseVersion }} ({{ commitHash }} )</div>
		</div>
		<div>
			<pdf-preview-dialog></pdf-preview-dialog>
		</div>

		<!-- EMAIL | MAIL | SMS DETAIL-->
		<action-detail-dialog
			style="z-index: 5000"
			:visible="actionDetailDialogVisibleStore"
			:component-type="componentTypeStore">
		</action-detail-dialog>
		<!-- //EMAIL | MAIL | SMS DETAIL-->

		<!-- PHONE -->
		<action-phone-detail-overlay
			style="z-index: 5000"
			:action="actionPhoneDetailOverlayAction"
			:visible="actionPhoneDetailOverlayVisible">
		</action-phone-detail-overlay>

		<create-phone-action-overlay>
		</create-phone-action-overlay>

		<email-detail-dialog
			style="z-index: 5000"
			:visible="emailDetailDialogVisibleStore"
			:message-ref="emailDetailDialogMessage">
		</email-detail-dialog>

	</div>
</template>

<script>
import PDFPreviewDialog from '@/components/_dialogs/PDFPreviewDialog';
import { mapGetters } from 'vuex';
import Logging from '@/logging';
import ActionPhoneDetailOverlay from '@/components/ActionPhoneDetailOverlay.vue';
import CreatePhoneActionOverlay from '@/components/CreatePhoneActionOverlay.vue';
import { fetchAndStoreParticipantUsers } from '@/helpers/permission-helper';

export default {
	name: 'App',
	components: {
		'pdf-preview-dialog': PDFPreviewDialog,
		ActionPhoneDetailOverlay,
		CreatePhoneActionOverlay
	},
	data() {
		return {
			initialized: false,
			maintenance: false
		};
	},
	computed: {
		...mapGetters([
			'fullscreenLoading',
			'selectedAction',
			'actionDetailDialogVisibleStore',
			'componentTypeStore',
			'actionTableVisibleStore',
			'actionPhoneDetailDialogVisibleStore',
			'actionPhoneDetailOverlayVisible',
			'actionPhoneDetailOverlayAction',
			'emailDetailDialogVisibleStore',
			'emailDetailDialogMessage',
			'selectedParticipantStore',
			'selectedLegalEntityStore'
		]),
		commitHash() {
			return process.env.VUE_APP_GIT_COMMIT || '';
		},
		releaseVersion() {
			return process.env.VUE_APP_RELEASE_VERSION || '';
		},
		participantLegalEntityWatch() {
			return [this.selectedParticipantStore, this.selectedLegalEntityStore];
		}
	},
	watch: {
		// Fetch participant users whenever the selected participant changes
		participantLegalEntityWatch(newValues) {
			this.fetchParticipantUsers(newValues[0], newValues[1]);
		}
	},
	async created() {
		// =========
		// ENV VARS
		// =========
		this.$store.commit('risolto/SET_ENVIRONMENT', process.env.VUE_APP_ENVIRONMENT);
		this.$store.commit('risolto/SET_BETA', process.env.VUE_APP_BETA);

		// =======
		// LOCALE
		// =======
		try {
			const lang = localStorage.getItem('rslt-language');
			if (lang) {
				this.$i18n.locale = lang;
			}
		} catch (e) {
			Logging.error(e);
		}
	},
	methods: {
		async fetchParticipantUsers(participant, legalEntity) {
			await fetchAndStoreParticipantUsers(this.$apollo, this.$store, participant, legalEntity);
		}
	}
};
</script>
<style lang="scss">
.warning {
	position: fixed;
	width: 100%;
	z-index: 999999;
}

#app.maintenance {
	padding-top: 36px;

	.sidebar-container {
		padding-top: 36px;
	}
}
</style>
